import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { MenuItem } from '../../_models/admin/menu.item';
import { Animations } from '../../_animations/animations';
import { Router } from '@angular/router';
import { AdminService } from '../../_services/admin/admin.service';
import { HotkeyService } from 'app/_services/hotkey.service';

@Component({
  selector: 'app-admin-menu-item',
  templateUrl: './admin-menu-item.component.html',
  styleUrls: ['./admin-menu-item.component.scss'],
  animations: [Animations.slideInOut]
})
export class AdminMenuItemComponent implements OnInit {
  @Input() menuItem: MenuItem;
  @Input() isMainMenu: boolean;
  @Input() search: RegExp;
  @Input() parentSearchHit: boolean;
  @Output() clickMenu: EventEmitter<number> = new EventEmitter();
  @Input() activeMenuId: number;
  @Output() activeMenuIdChange: EventEmitter<number> = new EventEmitter();
  hotkeyHtml: string;

  constructor(
    public adminService: AdminService,
    private hotkeyService: HotkeyService,
    private router: Router
  ) { }

  ngOnInit() {
    this.hotkeyHtml = this.hotkeyService.getHotKeyHtml(this.menuItem?.Hotkeys);
  }

  isActive(menuItem: MenuItem): boolean {
    if (this.activeMenuId === menuItem.ID) return true;
    var active = false;
    if (menuItem.SubMenu) {
      menuItem.SubMenu.forEach(subItem => {
        if (!active) active = this.isActive(subItem);
      });
    }
    return active;
  }

  getRouterLink(): string[] {
    if (this.menuItem && this.menuItem.Route) { return [this.menuItem.Route]; }
    return null;
  }

  clickMe(event: MouseEvent): void {
    if (this.isActive(this.menuItem)) {
      if (this.menuItem.ParentID === 0) this.activeMenuId = -1;
      else this.activeMenuId = this.menuItem.ParentID;
    } else {
      this.activeMenuId = this.menuItem.ID;
    }
    this.activeMenuIdChange.emit(this.activeMenuId);
  }

  searchHit(menuItem: MenuItem, search: RegExp): boolean {
    if (search && (menuItem.Title.search(search) !== -1
      || (menuItem.Keywords && menuItem.Keywords.search(search) !== -1))) { return true; }
    return false;
  }

  childSearchHit(menuItem: MenuItem, search: RegExp): boolean {
    if (search && menuItem) {
      if (menuItem.SubMenu) {
        let hit = false;
        menuItem.SubMenu.forEach(item => {
          if (!hit && this.searchHit(item, search)) {
            hit = true;
          }
          if (!hit) { hit = this.childSearchHit(item, search); }
        });
        if (hit) { return true; }
      }
    }
    return false;
  }

}
